var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 43 47",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("path", {
          attrs: { id: "leapsigh-iso@3x_svg__a", d: "M0 .166h35.07v38.89H0z" }
        }),
        _c("path", {
          attrs: {
            id: "leapsigh-iso@3x_svg__c",
            d: "M.615.456H27.78v46.6H.615z"
          }
        }),
        _c("path", {
          attrs: { id: "leapsigh-iso@3x_svg__e", d: "M0 .456h15.952v30.72H0z" }
        })
      ]),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("g", { attrs: { transform: "translate(0 7.544)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-iso@3x_svg__b", fill: "#fff" } },
            [_c("use", { attrs: { "xlink:href": "#leapsigh-iso@3x_svg__a" } })]
          ),
          _c("path", {
            attrs: {
              d:
                "M19.579 31.347h-.114c-6.482 0-11.755-5.273-11.755-11.755V.166H0v19.426c0 10.733 8.732 19.464 19.465 19.464H35.07v-7.71H19.579z",
              fill: "#FBAE17",
              mask: "url(#leapsigh-iso@3x_svg__b)"
            }
          })
        ]),
        _c("path", {
          attrs: {
            d:
              "M35.07 23.335H19.466c-1.35 0-2.642-.24-3.85-.66v4.46c0 1.225.119 2.423.337 3.586 1.14.21 2.313.323 3.513.323H42.78v-7.709h-7.71z",
            fill: "#75CDDC"
          }
        }),
        _c("g", { attrs: { transform: "translate(15 -.456)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-iso@3x_svg__d", fill: "#fff" } },
            [_c("use", { attrs: { "xlink:href": "#leapsigh-iso@3x_svg__c" } })]
          ),
          _c("path", {
            attrs: {
              d:
                "M20.07 31.5v7.847h.01-.01c-5.105-.004-9.448-3.286-11.063-7.846a11.674 11.674 0 01-.682-3.91V.457H.615V27.59c0 1.226.119 2.423.337 3.586a19.373 19.373 0 003.627 8.17c3.556 4.678 9.176 7.706 15.492 7.709H27.78V31.5h-7.71z",
              fill: "#2CA2B5",
              mask: "url(#leapsigh-iso@3x_svg__d)"
            }
          })
        ]),
        _c("g", { attrs: { transform: "translate(0 -.456)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-iso@3x_svg__f", fill: "#fff" } },
            [_c("use", { attrs: { "xlink:href": "#leapsigh-iso@3x_svg__e" } })]
          ),
          _c("path", {
            attrs: {
              d:
                "M15.615 27.592V23.13c-4.594-1.6-7.906-5.962-7.906-11.094V8.166h7.906V.456H0v11.58c0 6.32 3.03 11.943 7.71 15.5a19.364 19.364 0 008.242 3.64 19.435 19.435 0 01-.337-3.584",
              fill: "#F37C20",
              mask: "url(#leapsigh-iso@3x_svg__f)"
            }
          })
        ]),
        _c("path", {
          attrs: {
            d: "M7.71 27.081V7.709H0v3.871c0 6.32 3.03 11.943 7.71 15.501",
            fill: "#DD5A26"
          }
        }),
        _c("path", {
          attrs: {
            d: "M35.07 46.6v-7.71H19.58c3.556 4.679 9.176 7.707 15.492 7.71",
            fill: "#298594"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M15.615 22.675v4.46c0 1.226.12 2.423.337 3.586 1.14.209 2.313.324 3.512.324h4.543a11.674 11.674 0 01-.683-3.91v-3.8h-3.86c-1.349 0-2.64-.24-3.849-.66",
            fill: "#3A595E"
          }
        }),
        _c("path", {
          attrs: { d: "M35.07 46.6h.01-.01M35.07 38.89h.01-.01z", fill: "#000" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }